var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-icon',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip",value:({ placement: _vm.tooltipPlacement, boundary: 'viewport' }),expression:"{ placement: tooltipPlacement, boundary: 'viewport' }"}],staticClass:"gl-inline-flex gl-text-secondary",attrs:{"aria-label":_vm.visibilityTooltip,"name":_vm.visibilityIcon,"title":_vm.visibilityTooltip}})
}
var staticRenderFns = []

export { render, staticRenderFns }